import { Link } from 'react-router-dom'
import styles from './Navbar.module.scss'

const Navbar = ({ onLogout }) => {
  return (
    <nav className={styles.navbar}>
      <ul>
        <li>
          <Link to='/'>Screens</Link>
        </li>
        <li>
          <Link to='/about'>About</Link>
        </li>

        <li tabIndex='0' onKeyDown={onLogout} onClick={onLogout}>
          Logout
        </li>
      </ul>
    </nav>
  )
}

export default Navbar
